<main class="shippn-b2b-pages-main-wrapper">
  <aside class="shippn-b2b-pages-nav-wrapper">
    <div class="shippn-b2b-pages-nav-profile">
      <h5 translate="no">
        {{memberDetails?.company_name}}
        <span class="show-on-hover"
          (click)="copyToClipboard(memberDetails?.email, 'Email')">{{memberDetails?.email}}</span>
      </h5>
    </div>
    <div class="shippn-b2b-pages-nav-menu">
      <button [routerLink]="['/', 'b2b', 'create-shipment']"> <i class="fas fa-box-open"></i> Create
        Shipment</button>
      <button [routerLink]="['/', 'b2b', 'dashboard']"> <i class="fas fa-boxes"></i>
        Shipments</button>
      <button [routerLink]="['/', 'b2b', 'pickups']" class="active"> <i class="fas fa-shipping-fast"></i>
        Pickups</button>
    </div>

    <div class="shippn-b2b-page-nav-footer for-desktop">
      <button class="btn btn-light" [routerLink]="['/', 'settings', 'api-keys']"><i class="fas fa-user-cog"></i>
        Account Settings</button>
    </div>
  </aside>
  <section class="shippn-b2b-pages-content-wrapper">
    <div class="shippn-b2b-pages-content-filters-wrapper">
      <div class="b2b-dashboards-filter-controls-wrapper">
        <div
        style="text-align: center; width: 100%; height: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0 15px;"
        class="dashboard-bfm-tab-head">
        <div class="environment">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down"
              style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;"
              aria-hidden="true"></i>
            <select name="" id=""
              style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
              [(ngModel)]="environment" (change)="handleEnvironmentChange()" class="b2b-pickups-environment-select">
              <option value="environment" disabled>Environment</option>
              <option value="production">Production</option>
              <option value="test" [disabled]="!xApiToken">Test</option>
            </select>
          </div>
        </div>
        <div style="display: inline-flex;align-items: center;height: 100%;">

        </div>
        <div>
          <button class="btn shippn-from-to-area-go-btn b2b-pickups-schedule-pickup-cta"
            (click)="openSchedulePickupDialog()">Schedule Pickup</button>
        </div>
      </div>
      </div>
      
    </div>

    <div class="shippn-b2b-pages-content-content-wrapper">
      <div class="table-container table-responsive b2b-table-responsive">
        <table mat-table [dataSource]="searchResults.pickups">
          <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef>
              {{ column.header }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ column.cell(row) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <mat-paginator [length]="searchResults.total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex" showFirstLastButtons="true" aria-label="Select page" (page)="handlePageEvent($event)">
      </mat-paginator>
    </div>
  </section>
</main>